import React from 'react'

const FeaturedImagePlaceholder = () => {
    return (
        <div className="featured-image-placeholder">
            
        </div>
    )
}

export default FeaturedImagePlaceholder